// extracted by mini-css-extract-plugin
export var columnList = "_bi-0";